export default __webpack_public_path__ + "img/IyJJVHJb.d3db34fa.svg";